import { fetchApi } from '@/config/axiosSetting';
import {
  getDamagedTabsQueryParams,
  ParticipantsTabType,
} from '@/modules/adjusterReportModules/IncidentParticipants/queries/getParticipantsTabs/getParticipantsTabs.type';

export const getDamagedTabsQueryFunction = (
  params: getDamagedTabsQueryParams,
): Promise<ParticipantsTabType[]> => {
  return fetchApi.get(
    `/property/reports/${params?.id}/accident_users/entry_tabs/`,
    {
      params,
    },
  );
};
